import css from './video-hero-section.module.scss';
import LoopedVimeoPlayer from "@/components/Video/LoopedVimeoPlayer";
import {ContentItem, ProductFull} from "@api";

export const enum VideoHeroSectionSizeEnum {
    Default,
    Large,
}

interface VideoHeroSectionProps {
    videoId: number;
    mobileVideoId: number;
    product: ProductFull;
    pageContent?: Record<string, ContentItem>;
    sectionSize?: VideoHeroSectionSizeEnum;
}

const VideoHeroSection = ({ videoId, mobileVideoId, product, pageContent, sectionSize = VideoHeroSectionSizeEnum.Default }: VideoHeroSectionProps) => {
    return <section className='md:px-6 mb-0 md:mb-8'>
        <div className={`relative h-screen md:max-lg:h-fit ${sectionSize === VideoHeroSectionSizeEnum.Default ? 'lg:max-h-[500px]' : 'lg:max-h-[600px]'} md:rounded-2xl overflow-hidden mx-auto ${css['section']}`}>
            <div className="absolute max-md:w-full md:left-12 lg:left-28 md:bottom-1/2 md:translate-y-1/2 max-md:top-[60px] z-40 font-semibold">
                <p className='lg:text-7xl text-5xl max-md:hidden'>{(pageContent?.["hero.headline"]?.data) ?? product.title}</p>
                <p className="md:hidden text-5xl text-center">{(pageContent?.["hero.headline"]?.data) ?? product.title}</p>

                <p className='font-semibold text-2xl max-md:w-full max-md:text-center'>{pageContent?.["hero.subhead"]?.data}</p>
            </div>
            <div className='h-full hidden md:block'>
                <LoopedVimeoPlayer videoId={videoId} />
            </div>
            <div className='h-full block md:hidden'>
                <LoopedVimeoPlayer videoId={mobileVideoId} />
            </div>
        </div>
    </section>
}

export default VideoHeroSection;
